/** Fetching media that lives behind the API's authentication.
 *
 * A plain `<audio src="/api/...">` is a browser request with NO
 * Authorization header, so the API answers 401 and the player sits at 0:00
 * with no way to say why. That is exactly what shipped for Hoeren audio.
 *
 * Deliberately its own module rather than part of `exams`: this is about
 * transport, not exams, and every test that mocks the exams API would
 * otherwise have to know about it.
 */
import { API_BASE, getTokens } from "./http";

/** True when a media URL points at OUR api and therefore needs the token. */
export function needsAuth(url: string): boolean {
  return url.startsWith(API_BASE) || url.startsWith("/api/");
}

/** Fetch a recording as a blob, carrying the session token. */
export async function fetchMedia(url: string): Promise<Blob> {
  const { access } = getTokens();
  const headers: Record<string, string> = {};
  if (access) headers.Authorization = `Bearer ${access}`;
  const res = await fetch(url, { headers });
  if (!res.ok) throw new Error(`media unavailable: ${res.status}`);
  return res.blob();
}
